// Generated by ts-to-zod
import { z } from 'zod'

import { countryCodeSchema } from './enums.zod'

export const addressValueSchema = z.object({
  countryCode: countryCodeSchema,
  zipCode: z.string().optional().nullable(),
  city: z.string().optional().nullable()
})

export const geoAddressValueSchema = z.object({
  coordinates: z.string().optional().nullable()
})

export const unlistedAddressValueSchema = z.object({
  isUnlistedAddress: z.boolean().optional(),
  plotArea: z.string().optional().nullable(),
  plotOfLand: z.string().optional().nullable()
})
